import { Link, useHistory, useLocation } from 'react-router-dom';
import { Layout, Menu, Select } from 'antd';
import logo from '../../../assets/images/logo.svg';
import MenuKeys from '../../../constants/menu';
import map from 'lodash/map';
import get from 'lodash/get';
import includes from 'lodash/includes';
import './style.scss';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { switchHospital, loginMoreRoles } from '../../../redux/actions/authAction';
import { DASHBOARD, getLeftPanelKey } from '../../../constants/routes';
import { CloseCircleOutlined, CloseOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Sider } = Layout;

export default function LayoutSider({ setIsLoading, showSidePanel, menuButtonClose }) {
  const [activeKey, setActiveKey] = useState('0');
  const roles = useSelector((state) => get(state, 'auth.roles'));
  const allRolesWithHospitals = useSelector((state) => get(state, 'auth.allRoles'));
  const hospitalList = useSelector((state) => get(state, 'auth.hospitals'));
  const userEmail = useSelector((state) => get(state, 'auth.user.email'));
  const tempPassword = useSelector((state) => get(state, 'auth.tempPassword'));
  const currentRole = useSelector((state) => get(state, 'auth.currentRole'));
  const media = window.matchMedia(`(min-width: 1023px)`);
  const currentHospital = useSelector((state) => get(state, "auth.currentHospital"));
  const history = useHistory();
  const dispatch = useDispatch();

  const getCurrentSelectedValue = () => {
    if (!currentRole) return '';
    return `${currentRole.name}-${currentRole.value}-${currentRole.hospital_name}`;
  };

  const getUniqueRoles = (rolesArray) => {
    if (!Array.isArray(rolesArray)) return [];
    const seen = new Set();
    return rolesArray.filter(role => {
      if (!role?.value) return false;
      const uniqueKey = `${role.name}-${role.value}-${role.hospital_name}`;
      if (seen.has(uniqueKey)) return false;
      seen.add(uniqueKey);
      return true;
    });
  };

  const handleSwitchHospitalAndRole = (value) => {
    setIsLoading(true);
    const [name, roleValue, hospital] = value.split('-');
    const selectedRole = allRolesWithHospitals.find(role => 
      role.name === name && 
      role.value === parseInt(roleValue) && 
      role.hospital_name === hospital
    );
    
    if (selectedRole) {
      dispatch(loginMoreRoles({ 
        email: userEmail,
        password: tempPassword
      }, selectedRole))
        .then(() => {
          setIsLoading(false);
          menuButtonClose();
          history.push(DASHBOARD);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  };

  const location = useLocation();
  
  return (
    <Sider className={`left-side-panel ${showSidePanel ? "open" : "close"}`}>
      <div className="logo">
        <img src={logo} alt="logo" />
        {!media.matches && ( <CloseOutlined onClick={menuButtonClose}/>)}
      </div>

      {/* Role and Hospital Selector */}
      {!includes(roles, 1) && (
        <Select
          className="hospital-selector"
          onChange={handleSwitchHospitalAndRole}
          value={getCurrentSelectedValue()}
        >
          {getUniqueRoles(allRolesWithHospitals).map((role) => (
            <Option 
              key={`${role.name}-${role.value}-${role.hospital_name}`}
              value={`${role.name}-${role.value}-${role.hospital_name}`}
            >
              <div className="hospital-option">
                <img
                  src={get(hospitalList.find(h => h.name === role.hospital_name), 'logo_url.url')}
                  alt=""
                  style={{ width: "30px" }}
                />
                {`${role.name} - ${role.hospital_name}`}
              </div>
            </Option>
          ))}
        </Select>
      )}

      <Menu
        selectedKeys={[getLeftPanelKey(get(location, "pathname"))]}
        className="sider-menu"
        mode="inline"
        onClick={({ key }) => {setActiveKey(parseInt(key)); menuButtonClose(); }}
      >
        {map(MenuKeys, (m, i) => {
          return (
            get(m, "allowed_roles").some((role) => roles.includes(role)) && (
              <Menu.Item
                key={get(m, "key")}
                icon={
                  activeKey === i ? (
                    <img src={get(m, "active_icon")} alt="" />
                  ) : (
                    <img src={get(m, "inactive_icon")} alt="" />
                  )
                }
                onClick={({ key }) => { 
                   setActiveKey(parseInt(key)); menuButtonClose(); }}
              >
                <Link to={get(m, "route")}>{get(m, "name")}</Link>
              </Menu.Item>
            )
          );
        })}
      </Menu>
    </Sider>
  );
}
